import { render } from "./Customer_Inquiries.vue?vue&type=template&id=21c1a038"
import script from "./Customer_Inquiries.vue?vue&type=script&lang=js"
export * from "./Customer_Inquiries.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__